<template>
	<div
		class="task-sidebar-block bg-white"
		@click="openTaskSidebar(task)"
	>
		<div class="info-task-one">
			<div :class="`task-tags ${handlerStyleTags(task)}`">
				<span v-html="handlerTypeTaskTag(task)"></span>
			</div>
			<div class="task-tags-act ml-2">
				<span :class="`text-secondary`" v-html="handlerTypeReferenceId(task.reference_type_id)"></span>
			</div>
		</div>
		<div class="info-task-two line-height-17 mt-2">
			<span class="font-size-16 text-brown">{{ task.title }}</span>
		</div>
		<div class="info-task-two font-size-14 mt-2">
			<span class="text-brown max-lines-2">{{ task.description }}</span>
		</div>
		<div class="info-task-two font-size-12 mt-2" v-if="task.company_id">
			<span class="text-brown">Клиент: {{ task.company.name }}</span>
		</div>
		<div class="info-task-two font-size-12 mt-2" v-if="task.order_id">
			<span class="text-brown">Заказ: #{{ task.order_id }}</span>
		</div>
		<div class="info-task-two font-size-12" v-if="task.order">
			<span class="text-brown">Клиент: {{ task.order.company ? task.order.company.name : task.order.temp_name }}</span>
		</div>
		<div class="info-task-two font-size-12 mt-2" v-if="task.finance_id">
			<span class="text-brown">Счет: {{ task.finance.invoice_number ? '#' + task.finance.invoice_number : 'номер не задан' }}</span>
		</div>

		<div class="info-task-three mt-2">
			<span class="text-secondary">дата исполнения: {{ transformDate(task.realization_at) }}</span>
			<div class="text-right flex-grow-1">
				<span class="task-id">#{{ task.id }}</span>
			</div>
		</div>
	</div>
</template>

<script>
import { openTaskSidebar } from '@/mixins/openTaskSidebar';
import { mixinTasks } from '@/mixins';

export default {
	props: {
		task: { type: Object, default: () => ({}) }
	},
	mixins: [
		mixinTasks,
		openTaskSidebar
	],
	methods: {
		transformDate(date) {
			if (date) {
				return new Date(date).toLocaleString('ru-RU', { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' });
			} else {
				return new Date().toLocaleString('ru-RU', { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' });
			}
		},
	},
};
</script>

<style>
.task-sidebar-block {
  margin-bottom: 10px;
  padding: 10px;
  border-radius: 10px;
  width: 100%;
  cursor: pointer;
}
.max-lines-2 {
	overflow: hidden;
	display: -webkit-box;
	-webkit-line-clamp: 3; /* number of lines to show */
	line-clamp: 3; 
	-webkit-box-orient: vertical;
}
</style>
